import React from "react";
import { Row, Col, Input, Label, Button, Card, CardBody } from "reactstrap";
import { useDataFetch } from "../../Hooks/Use-data-fetch";

const DashboardFilters = ({
    filters,
    setFilters,
    onClear
}) => {
    const { getData } = useDataFetch();
    
    // Obtener departamentos directamente
    const { data: departmentsResponse } = getData(
        ['departments'],
        '/address/provinces/by-country',
        {},
        { country_id: '6873173cf6b95077fc0f0c80' }
    );

    const departments = departmentsResponse?.data?.provinces || [];

    const { data: citiesResponse } = getData(
        ['cities', filters.department],
        '/address/cities/by-province',
        {},
        { province_id: filters.department || '' },
        { 
            enabled: !!filters.department && filters.department !== '' 
        }
    );

    const cities = citiesResponse?.data?.cities || [];

 
    const handleDepartmentChange = (e) => {
        const departmentId = e.target.value;
        setFilters({
            ...filters,
            department: departmentId,
            city: '' 
        });
    };

    const handleCityChange = (e) => {
        setFilters({
            ...filters,
            city: e.target.value
        });
    };

    return (
        <Card className="mb-4">
            <CardBody>
                <Row className="g-3 align-items-end">
                    <Col md="5">
                        <Label>Departamento</Label>
                        <Input
                            type="select"
                            value={filters.department || ''}
                            onChange={handleDepartmentChange}
                        >
                            <option value="">Todos</option>
                            {departments.map((department) => (
                                <option
                                    key={department.id}
                                    value={department.id}
                                >
                                    {department.name}
                                </option>
                            ))}
                        </Input>
                    </Col>

                    <Col md="5">
                        <Label>Ciudad</Label>
                        <Input
                            type="select"
                            value={filters.city || ''}
                            onChange={handleCityChange}
                            disabled={!filters.department}
                        >
                            <option value="">Todas</option>
                            {cities.map((city) => (
                                <option
                                    key={city.id}
                                    value={city.id}
                                >
                                    {city.name}
                                </option>
                            ))}
                        </Input>
                    </Col>

                    <Col md="2">
                        <Button
                            color="light"
                            className="w-100"
                            onClick={onClear}
                        >
                            Limpiar filtros
                        </Button>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default DashboardFilters;